import { Col, Container, Row } from "react-bootstrap";
import logo from "./apcfss.jpg";
import logo1 from "./cm_new.png";
import logo2 from "./9-2.jpg";
import logo3 from "./abt.png";
import logo4 from "./min.jpg";
import logo5 from "./new.gif";
import logo6 from "./500x300_5993_mounteve.jpg";

import { Socialtabsform } from "./socialtabsform";
export function Socialwel() {

  function hello() {

    alert("willbe available soon");
  }



  return (
    <>
      <Row style={{ backgroundColor: "#cc7289", height: "50px" }}>
        <h5 style={{ fontSize: "20px", padding: "10px", color: "white", justifyContent: "center", }}>Welcome to Social Welfare Department</h5></Row>
      <Row >
        <Col xs={2} sm={2} md={2} lg={2} >
          {" "}
          <img
            src={logo}
            className="img-responsive"
            style={{
              padding: "10px",

              height: "120px",
              marginLeft: "350px"

            }}
          />
        </Col>
        -
        <Col xs={2} sm={2} md={2} lg={2} >
          {" "}
          <img
            src={logo1}
            className="img-responsive"
            style={{
              padding: "10px",

              height: "120px",
              marginLeft: "650px"

            }}
          />
        </Col></Row>
      <Row style={{ backgroundColor: "#dbd7d8", height: "460px" }}>
        <Col md={8} style={{ backgroundColor: "#dee2e3", marginLeft: "450px", width: "1000px" }}>

          <img
            src={logo2}
            className="img-responsive"
            style={{
              padding: "10px",
              height: "350px",
              marginLeft: "20px"


            }} />
          <br></br><b style={{ marginLeft: "800px", marginTop: "-400px" }}> Backlog Vacancies </b>

          <Col style={{ backgroundColor: "#d1dde0" }}><h5>The Social Welfare department is dedicated to the integrated
            and overall development of SCHEDULED CASTES. According to 2001 census, the scheduled caste's
            population in the state is 123.39 lakhs, which accounts for 16.19 per cent of the State's total population. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;							<a type="button" href="https://socialwelfare.apcfss.in/Aboutus.html">Know More</a>

          </h5>  </Col>
        </Col>
      </Row>
      <Socialtabsform></Socialtabsform>
      <br></br>
      <Row>
        <Col md={2} style={{ border: "1px solid #c7bcb5", backgroundColor: "#dbd7d8", marginLeft: "450px", height: "450px", justifyContent: "center" }}>
          &nbsp;            <b style={{ color: "#95a182" }}> A &nbsp;B &nbsp;O &nbsp;U &nbsp;T <br></br>&nbsp;  S &nbsp;O &nbsp;C &nbsp;I &nbsp;A &nbsp;L <br></br>&nbsp;  W &nbsp;E &nbsp;L &nbsp;F &nbsp;A &nbsp;R &nbsp;E</b><center>
            <b style={{ fontSize: "12px", color: "#545452" }}><br></br>
              <br></br>
              <br></br>
              The Social Welfare Department is dedicated to the integrated and overall development of SCHEDULED
              CASTES and the implementation of the Schedule Caste Sub Plan. According to the 2011 Census,
              the Scheduled Castes population in the State is 84,69,278 which accounts for 17.08% of the State’s population.
              <br></br>                <br></br>                <br></br>


              GOALS AND OBJECTIVES-   

              The main objectives of the Social Welfare Department are Educational Advancement, Socio-Economic ......

            </b></center></Col>

        <Col md={2} style={{ border: "1px solid #c7bcb5", backgroundColor: "#dbd7d8", marginLeft: "50px", height: "450px", justifyContent: "center" }}>
          <h5 style={{ color: "#95a182", marginTop: "20px" }}>S&nbsp;C&nbsp;H&nbsp;E&nbsp;M&nbsp;S&nbsp;<br></br> D&nbsp;ET&nbsp;A&nbsp;I&nbsp;L&nbsp;S</h5>
          <img
            src={logo3}
            className="img-responsive"
            style={{
              marginTop: "100px",
              height: "250px",

            }}
          />

        </Col>

        <Col md={2} style={{ border: "1px solid #c7bcb5", backgroundColor: "#dbd7d8", marginLeft: "50px", height: "450px", justifyContent: "center" }}>


          <img
            src={logo4}
            className="img-responsive"
            style={{
              marginTop: "100px",
              height: "250px",

            }}
          />

        </Col>
      </Row>



      <br></br>


      <Row style={{ backgroundColor: "#c2897c", height: "30px" }}>




        <img
          src={logo6}
          className="img-responsive"
          style={{
            height: "350px",
            opacity: 0.4,

          }} />
      </Row>
      <Row style={{ height: "50px", color: "black" }}>
        <br></br>
        <h5 style={{ marginBottom: "100px" }}>W&nbsp;H&nbsp;O W&nbsp;E A&nbsp;R&nbsp;E
        </h5>
        <h5 style={{}}>The Social Welfare Department looks after the welfare of the  Scheduled Castes in the State.
          the Department of Social Welfare is headed by a Minister of Social Welfare and is    assisted by the Principal Secretary,
          Social Welfare at the Government Level which is responsible for policy formulation and management of the Budget.
          At the field level five HODs carry out the day to functions of the Social Welfare Department.
          <a href="https://socialwelfare.apcfss.in/Aboutus.html" >Know More</a>
        </h5>
      </Row>
      <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>

      <Col style={{ backgroundColor: "#635350", height: "320px" }}>
        <br></br>
        <h5 style={{ color: "white", marginLeft: "400px", fontStyle: "italic" }}>Contact Us @</h5>
        <div style={{ marginTop: "30px" }}> <b style={{ color: "white", marginLeft: "400px" }}>
          Directorate of Social Welfare Andhra Pradesh,</b><br></br>
          <b style={{ color: "white", marginLeft: "400px" }}>T.G Plaza Building,Tadepalli,</b> ,<br></br>
          <b style={{ color: "white", marginLeft: "400px" }}>In front of Manipal Hospital,</b><br></br>
          <b style={{ color: "white", marginLeft: "400px" }}>Guntur Disrict ,</b><br></br>
          <b style={{ color: "white", marginLeft: "400px" }}>Andhra Pradesh.</b><br></br><br></br>
          <b style={{ color: "white", marginLeft: "400px" }}>Email: swcommissioner@gmail.com</b></div>

        <Col style={{ marginLeft: "390px", marginTop: "-220px" }}>

          <div style={{ marginTop: "30px" }}> <b style={{ color: "white", marginLeft: "400px" }}> </b>
            <h5 style={{ color: "white", fontStyle: "italic", marginLeft: "400px", marginTop: "-30px" }}>Related links</h5><br></br><br></br>
            <b style={{ color: "white", marginLeft: "400px", marginTop: "-50px" }}><a href="https://www.jnanabhumi.ap.gov.in/">JNANA BHUMI </a></b> <br></br><br></br>
            <b style={{ color: "white", marginLeft: "400px" }}><a href="https://jnbnivas.apcfss.in/">Hostels and Residential Schools</a></b><br></br><br></br>
            <b style={{ color: "white", marginLeft: "400px" }}><a href="https://jnbnivas.apcfss.in/" target="_blank">Hostels and Residential Schools</a></b><br></br>
          </div>

        </Col>
        <Col style={{ marginLeft: "1150px", marginTop: "-210px" }}>
          <textarea type="text" name="name" placeholder="Name" ></textarea><br></br><br></br>
          <textarea type="text" name="Email" placeholder="Email"></textarea><br></br><br></br>
          <textarea type="text" name="Message" placeholder="Message"></textarea><br></br>
          &nbsp;<button type="submit" style={{ backgroundColor: "#d1968c", border: "white" }} onClick={hello}> submit</button>
        </Col>
      </Col>




    </>
  )
}